import Vue from 'vue'
/**
 * Change date type report
 * @author Luis Rodriguez
 * @param id Affected id
 * @param dateType New date type
 * @return {Object}
 */
const changeDateTypeReport = (id, dateType) =>
  Vue.$http.put(`sinisters/affected/${id}/type_date/`, dateType)
    .then()
    .catch(err => { throw err })

export default changeDateTypeReport



// WEBPACK FOOTER //
// ./src/services/sinister/changeDateTypeReport.js